import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { getCount } from "../actions/getCountAction";

const initialState = {
    Object:null,
    loading : 'idle',
    hasError: false,
    errorMessage: ''
}
const countSlice = createSlice({
    name: 'count',
    initialState,
    reducers: {
         resetState: () => {
            return initialState;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(getCount.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
            })
            .addCase(getCount.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.hasError = false;
                state.Object = action.payload ;
                state.errorMessage = ""


            })
            .addCase(getCount.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
            })
    }
});
export const { deleteFileById , resetState } = countSlice.actions;

export default countSlice.reducer;